export const PAGES = {
  WORKSPACE: "workspace",
  PROJECT: "project",
  EDITOR: "editor",
  ERROR: "error",
  CONNECT: "connect",
  HOME: "home",
  SUBSCRIPTION_CREATED_REDIRECT: "subscription_created_redirect",
};
